import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/authcontext";
import { useTenantRole } from "./TenantRoleDisplay";
import Card from "./ui/404-component";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { selectedTenantId } = useContext(AuthContext);
  const role = useTenantRole(selectedTenantId || "");

  const handleGoHome = () => {
    if (!role) {
      navigate("/dashboard/crm-dashboard", { replace: true });
      return;
    }

    if (
      role.role_key === "SUPERADMIN" ||
      role.role_key === "PLATFORM_ANALYST"
    ) {
      navigate("/dashboard/crm-dashboard", { replace: true });
    } else {
      navigate("/dashboard/crm-dashboard", { replace: true });
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100">
      <div className="text-center">
        <div style={{ transform: "scale(0.7)" }}>
          <Card />
        </div>
        <h2 className="display-6 fw-bold mb-3">Page Not Found</h2>
        <p className="lead mb-4">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <div className="d-flex gap-3 justify-content-center">
          <button className="btn btn-outline-primary" onClick={handleGoBack}>
            <i className="fas fa-arrow-left me-2"></i>
            Go Back
          </button>
          <button className="btn btn-primary" onClick={handleGoHome}>
            <i className="fas fa-home me-2"></i>
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
